__turbopack_context__.v({
  "head": "section-screen-module__lEYeWq__head",
  "headerBar": "section-screen-module__lEYeWq__headerBar",
  "main": "section-screen-module__lEYeWq__main",
  "subject": "section-screen-module__lEYeWq__subject",
  "title": "section-screen-module__lEYeWq__title",
});
